import { NgModule } from '@angular/core';
import { CoreModule } from './../core/core.module';
import { CommonModule } from '../common/common.module';
import { DebugOverviewComponent } from './overview/debug-overview.component';
import { DebugApiService } from './debug.service';

@NgModule({
  imports: [CommonModule, CoreModule],
  declarations: [DebugOverviewComponent],
  providers: [DebugApiService],
})
export class DebugModule {}
